import { motion } from "framer-motion";

const spring = { type: "spring", stiffness: 400 };

export const HoverCard = ({ children, className = "" }) => (
  <motion.div className={className} whileHover={{ x: 4 }} transition={spring}>
    {children}
  </motion.div>
);

export const HoverIcon = ({ children, className = "" }) => (
  <motion.div className={className} whileHover={{ scale: 1.1, rotate: 12 }} transition={spring}>
    {children}
  </motion.div>
);
